import React from 'react'
import Helmet from 'react-helmet-async'
import { compose, Mutation } from 'react-apollo'

import { GET_SONG } from '../../graphql/queries'
import { UPDATE_CREDIT } from '../../graphql/mutations'

import GetUser from '../../hocs/queries/GetUser'
import GetSong from '../../hocs/queries/GetSong'
import { GetCreditRefreshed } from '../../hocs/queries/GetCredit'

// Our Base Components
import Breadcrumb from '../../components/Breadcrumb'
import CreditForm from '../../components/CreditForm'
import SectionContainer from '../../components/SectionContainer'
import CreatePagesHeader from '../../components/CreatePagesHeader'

class SongCreditEdit extends React.Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Edit Credit | {this.props.song.title}</title>
        </Helmet>
        <main className='main'>
            <CreatePagesHeader
            title={this.props.song.title ?  `Assign Credit to ${this.props.song.title}` : '' }
            subtitle='Edit Song Credit'>
              <Breadcrumb items={[
                {
                  href: `/songs`,
                  name: 'Songs'
                },
                {
                  href: `/songs/${this.props.song.id}`,
                  name: this.props.song.title
                },
                {
                  href: `/songs/${this.props.song.id}/credits`,
                  name: 'Song Credits'
                },
                {
                  href: `/songs/${this.props.song.id}/credits/${this.props.credit.id}/edit`,
                  name: 'Edit Song Credit'
                }
              ]} />
              </CreatePagesHeader>
            <div className='sections-container'>
            <SectionContainer>
              <Mutation
                mutation={UPDATE_CREDIT}
                update={(cache, { data: { updateCredit } }) => {
                  const { getSong } = cache.readQuery({
                    query: GET_SONG,
                    variables: {
                      id: this.props.song.id
                    }
                  })
                  if (getSong) {
                    const song = { ...getSong }
                    song.credits = song.credits.map(credit => {
                      if (credit.id === updateCredit.id) {
                        return updateCredit
                      }

                      return credit
                    })
                    cache.writeQuery({
                      query: GET_SONG,
                      variables: {
                        id: this.props.song.id
                      },
                      data: {
                        getSong: song
                      }
                    })
                  }

                  this.props.history.push(`/songs/${this.props.song.id}`)
                }}>
                {(updateCredit, { loading, error }) => (
                  <CreditForm
                    {...this.props.credit}
                    onSubmit={(state) => {
                      let data = { ...state }
                      Object.keys(data).forEach((key) => (data[key] === '') && (data[key] = null))
                      updateCredit({
                        variables: {
                          ...data,
                          creditId: this.props.credit.id,
                          performing: data.performing ? true : false
                        }
                      }).catch(() => {
                        //
                      })
                    }}
                    loading={loading}
                    errors={error}
                    discardForm={true}
                    />
                )}
              </Mutation>
            </SectionContainer>
          </div>
        </main>
      </>
    )
  }
}

export default compose(
  GetUser,
  GetSong,
  GetCreditRefreshed
)(SongCreditEdit)
